<template>
        <div class="contenedorx" >
            <div class="item-1">
                <div ></div>
            </div>
            <div class="banner-top" style="background: radial-gradient(circle, rgba(87,109,228,1) 0%, rgba(56,56,173,1) 100%)">
                <div class="image_section">
                    <img src="/image/resource/omidres_rounded-01.png"
                   >
                </div>
                <div class="text-top-section">
                    <div ><h1 class="titulo">LOS 10 OBSTÁCULOS MAS FRECUENTES PARA LOS PROFESIONALES DE LA SALUD AL MOMENTO DE INICIAR TELEMEDICINA</h1></div><br>

                    <a href="#register" class="btn btn-primary mt-3 btnx">OBTENLO AQUÍ</a>
                </div>

            </div>
            <div v-if="postRegister == false">

                <div class="second_section" id="register">

                    <div class="form_email_section">
                         <span v-if="description">
                        <h5 style="text-align: justify; margin-top: 30px">
                            Muchos profesionales de la salud saben la importancia de hacer la transformación digital de sus servicios de salud, saben que sus pacientes necesitan apoyo y muchos están limitados a desplazarse.<br>

                            Y como médica en ejercicio, también conozco los miedos y dudas más frecuentes sobre este tema.<br>

                            Por eso, he creado la guia gratuita con LOS 10 OBSTACULOS MÁS FRECUENTES DE LOS PROFESIONALES DE LA SALUD AL MOMENTO DE INICIAR CON TELEMEDICINA, para aquellos que ven la necesidad de pasar su profesión al siguiente nivel, y así servir más y mejor a los pacientes.

                            Esperamos la disfrutes!

                        </h5>

                        <h3 style="font-weight: 800">Ingresa tu email.</h3>
                              </span>
                            <form-landing @close="description = false" :data_landing="data_landing"></form-landing>
                    </div>
                    <div class="content-text">
                        <div>
                            <img src="/image/landing/teleconsulta_descarga-01.svg" width="95%"
                            >
                        </div>
                    </div>
                    <a href="#register" class="btn btn-primary mt-3 btnx2">OBTENLO AQUI</a>
                </div>
            </div>
        </div>
</template>
<script>
    import {mapState} from 'vuex'
    import axios from 'axios'
    import FormLanding from './../resources/formLandig.vue'

    import VideoPost from './../resources/video_post_webinar.vue'
    import TelegramButon from './../resources/section_buton_telegram.vue'
    export default {
        metaInfo: {
        title: 'LOS 10 OBSTÁCULOS MAS FRECUENTES PARA LOS PROFESIONALES DE LA SALUD AL MOMENTO DE INICIAR TELEMEDICINA',
        titleTemplate: '%s - Dra Omidres Pérez!',
        content: 'Hagamos viral la salud con la Dra. Omidres Pérez',
        meta: [
            { name: 'Los 3 secretos que no te contaron para tener una consulta exitosa',
                content: 'Hagamos viral la salud con la Dra. Omidres Pérez',
                vmid: 'Hagamos viral la salud con la Dra. Omidres Pérez' }
        ],
        htmlAttrs: {
            lang: 'en',
            amp: true,

        }
    },
        name: 'form-amor',
        components: {
            TelegramButon,
            FormLanding,
            VideoPost
        },
        created(){

        },
        data(){
            return {
                bg_testi: '/image/resource/background_telegram-01.jpg',
                bg_estrella: '/image/resource/background_landig_four-01.jpg',
                postRegister:false,
                description:true,
                data_landing:{
                    urlRoom:'',
                    id_room:'',
                    date:'',
                    title: '10 Obstaculos en Telemedicina',
                    tag:'obstaculo-tm',
                    type:'1',
                    url_download:'https://firebasestorage.googleapis.com/v0/b/omidres-dashboard.appspot.com/o/Courses%2Ftelemedicina%20un%20clicl%2Fportada%2010%20errores%20telemedicina-01.pdf?alt=media&token=d77245e5-db96-47bb-98b7-382250677e7f'
                }
            }
        },
        computed: {
            ...mapState,


        },
        methods:{

        }

    }
</script>
<style scoped>
    .title-o{
        font-size: 1.2rem;
        font-weight: 700;
    }
    .contenedorx{
        display: grid;
        grid-template-rows: 60px minmax(80vh, auto) minmax(100vh, auto)  ;
        justify-content: center;
    }
    .btnx{
         height: 50px;
         font-size: 1.5rem;
         font-weight: 700;
         width: 50%;
     }
    .btnx2{
       display: none;
    }
    .banner-top{
        background-repeat: no-repeat;
        background-size: cover;
        display: flex;
        flex-direction: row;
        justify-content: center;
        padding-right: 50px;
        flex-wrap: nowrap;


    }
    .titulo{
        font-family: 'Exo 2', sans-serif;
        text-align: center;
        font-size: 3rem;
        color: white;
        font-weight: 800;
        line-height: 3rem;
        text-shadow: 2px 2px #36c6f9;

    }
    .image_section{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: 40%;

    }
    .image_section img{
        width: 70%;


    }
    .text-top-section{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 60%;

    }
    .second_section{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        width: 100%;
        padding: 20px 40px;
    }
    .expositores{
        display: flex;
        flex-direction: row;
        width: 47%;
        height: 160px;
        margin: 5px;
        justify-content: space-between;
        align-items: center;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        border-radius: 10px;
        padding: 10px;
    }
    .expositores:hover{
        box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.4), 0 6px 20px 0 rgba(0, 0, 0, 0.20);
    }
    .expositores img{
        width: 120px;
        height: 120px;
        margin-right: 10px;
    }

    .expositores .description{

    }

    .content-text{
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-content: flex-start;
        flex-wrap: wrap;
        padding: 10px 10px;

        width: 50%;
    }
    .form_email_section{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 50%;


    }

    .item-2-telegram{
        background-repeat: no-repeat;
        background-size: cover;
        display: flex;
        flex-direction: row;

        justify-content: center;
        padding-top: 30px;
    }


    @media (max-width: 1000px) {
        .contenedorx{
            padding: 0 10px;
        }
        .btnx2{
            height: 50px;
            font-size: 1.5rem;
            font-weight: 700;
            width: 40%;

        }
        .expositores{

            width: 100%;

        }
        .content-text{
            width: 100%;
        }
        .btnx{
            height: 50px;
            font-size: 1.5rem;
            font-weight: 700;
            width: 300px;

        }
        .banner-top{
            background-repeat: no-repeat;
            background-size: cover;
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            justify-content: center;
            align-content: center;
            padding-bottom: 30px;
        }
        .image_section img{
            width: 250px;
        }
        .image_section{
            justify-content: center;
            align-items: center;
            width: auto;
            height: 400px;
            margin-top: 10px;
        }
        .text-top-section{
            flex-direction: row;
            flex-wrap: wrap;
            align-content: center;
            justify-content: center;
            width: 90%;
            padding-left: 20px;

        }
        .content-text{
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-content: flex-start;
            margin-top: 40px;
            margin-bottom: 40px;
            padding: 0 20px;
        }
        .form_email_section{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            width: 80%;
            margin-top: 10px;

        }
        .titulo{
            font-family: 'Exo 2', sans-serif;
            font-size: 2.3rem;
            color: white;
            font-weight: 800;
            line-height: 3.4rem;
            text-shadow: 2px 2px #36c6f9;
            text-align: center;
            margin-top: -80px;
            width: 100%;
            padding: 0 10px;
        }


        .second_section{
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            flex-wrap: wrap;
            margin-top:2px;
        }


        .item-2-telegram{
            background-repeat: no-repeat;
            background-size: cover;
            display: flex;
            flex-direction: row;

            justify-content: center;
            padding-top: 30px;
        }
    }

</style>
